/**
 * Exercise Method used to in performing assignment.
 * tag: 747
 * @readonly
 * @enum {string} (char)
 */
export enum ExerciseMethod {
  /** Automatic */
  Automatic = 'A',
  /** Manual */
  Manual = 'M',
}
